module.exports = __webpack_public_path__ + "img/otsar.6c919f2d.png";